import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	commandLightTheme: {
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.command-light-theme',
		defaultMessage: 'Switch to light theme',
		description: 'Label shown to the user in the command palette for switching to light theme',
	},
	commandDarkTheme: {
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.command-dark-theme',
		defaultMessage: 'Switch to dark theme',
		description: 'Label shown to the user in the command palette for switching to dark theme',
	},
	commandAutoTheme: {
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.command-auto-theme',
		defaultMessage: 'Match system theme',
		description:
			'Label shown to the user in the command palette for switching theme to match system theme option',
	},
	themeKeywords: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-no-translate',
		defaultMessage:
			'switch to dark theme switch to light theme dark mode light mode change appearance change colors night mode day mode theme dark switch theme light switch theme switch switch theme appearance change colors change',
		description:
			'This message was moved to another folder, this one will be deleted when feature flag is cleaned. Do not translate',
	},
	themeKeywordsMisspelt: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.theme-keywords-misspelt-no-translate',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'lite theme darkmode lightmode nightmode daymode change colours change',
		description:
			'This message was moved to another folder, this one will be deleted when feature flag is cleaned. Do not translate',
	},
	autoThemeKeywords: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-no-translate',
		defaultMessage:
			'match system theme sync to system settings dark mode light mode change appearance change colors night mode day mode system theme match match theme system sync theme to system system theme sync theme dark switch theme light switch theme switch appearance change colors change',
		description:
			'This message was moved to another folder, this one will be deleted when feature flag is cleaned. Do not translate',
	},
	autoThemeKeywordsMisspelt: {
		// eslint-disable-next-line jira/i18n/id-named-by-package
		id: 'command-palette-integration.register-dynamic-commands.theme-mode-commands.auto-theme-keywords-misspelt-no-translate',
		defaultMessage:
			// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
			'match sistem theme sinc system theme matxh system theme match sytem theme darkmode lightmode nightmode daymode change colours change',
		description:
			'This message was moved to another folder, this one will be deleted when feature flag is cleaned. Do not translate',
	},
});
